define('viewmodels/RiskRating/RiskRatingFactorSetup',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'viewmodels/GeneralSettings', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, ObjGeneralSettings, utils) {

        var RiskFactorSetupVM = {
            attached: attached,
            format: format,
            ActionChanged: ActionChanged,
            appsecurity: appsecurity,
            AssessmentTypeList: ko.observableArray([]),
            AssessmentTypeListEdit: ko.observableArray([]),
            OptionsTypeList: ko.observableArray([]),

            //Risk Rating Areas
            RRAreaList: ko.observableArray([]),
            SelectedMRRAreaId: ko.observable(),
            
            RRAreaTabClick: RRAreaTabClick,
          
            GetRRCopyAreas: GetRRCopyAreas,
            GetCopyOverAreas: GetCopyOverAreas,
            SelectedAreaName: ko.observable(),
            ResponseOptionList: ko.observableArray([]),
          //  changedResponseType: changedResponseType,

            /* Languages */
            ObjGeneralSettings: ObjGeneralSettings,
            languageList: ko.observableArray([]),

            /* RiskLevels */
            riskLevels: ko.observableArray([]),
            riskLevelsDup: ko.observableArray([]),

            /* Risk Factors List */
            CurrentPageNumber: ko.observable(),
            RiskFactorList: ko.observableArray(),
            SelectedResponseRow: ko.observableArray([]),
            FactorResponsesList: ko.observableArray([]),
            FactorPopUpTitle: ko.observable(),
            FactorPopUpType: ko.observable(),
            SelectedFactorId: ko.observable(),
            questionResponses: ko.observableArray([]),
            selectedQuestionResponses: ko.observable(),
            parentFactorList: ko.observableArray(),
            selectedResponseTypeFactor: ko.observable(),
            selectedSubFactorResponseTypeFactor: ko.observable(),
            isReadOnlyFactorSelected: ko.observable(false),
            isHeaderFactorSelected: ko.observable(false),
            isConditionalFactorSelected: ko.observable(false),
            selectedFactor: ko.observable(),
            
            selectedLanguageFactorType: ko.observableArray([]),
            selectedLanguagesForFactor: ko.observableArray([]),
            factorLanguageList: ko.observableArray(),
            AddFactorFlag: ko.observable(),
            SelectedAssessmentTypeFactor: ko.observable(),
            ClickedFactorID: ko.observable(),

            AddFactorPopup: AddFactorPopup,
            EditFactorPopup: EditFactorPopup,
            onDeleteFactor: onDeleteFactor,
            deleteFactor: deleteFactor,
            rowExpandClick: rowExpandClick,
            parentQuestionChanged: parentQuestionChanged,
            PopulateParentQuestionAndResponseDropdowns: PopulateParentQuestionAndResponseDropdowns,
            questionTypeChangedFactor: questionTypeChangedFactor,
            resetRadioButtons: resetRadioButtons,
            saveRiskFactor: saveRiskFactor,
            FactorLanguageAdded: FactorLanguageAdded,
            

            /* Sub Factors */
            AddSubFactorFlag: ko.observable(),
            selectedSubFactor: ko.observable(new SubFactorModel({})),
            selectedLanguagesForSubFactor: ko.observableArray([]),
            currentSubFactorResponseTypes: ko.observable(),
            subFactorLanguageList: ko.observableArray(),
            CopyAreasListEdit: ko.observableArray([]),
            CopyAreasList: ko.observableArray([]),
            SelectedCopyAreas: ko.observable(),
            SurveyTitle: ko.observable(),
            SelectedRATForSubFactorEdit: ko.observableArray([]),
            ResponsePopUpTitle: ko.observable(),
            ResponsePopUpType: ko.observable(),
            SubFactorAssessmentTypeList: ko.observableArray([]),
            SubFactorAssessmentTypeListEdit: ko.observableArray([]),
            SelectedAssessmentTypesForSubFactor: ko.observable(),

            addSubFactorClick: addSubFactorClick,
            editSubFactorPopUp: editSubFactorPopUp,
            onDeleteSubFactor: onDeleteSubFactor,
            deleteSubFactor: deleteSubFactor,
            subFactorLangageAdded: subFactorLangageAdded,
            saveSubFactor: saveSubFactor,

            /* Response Types */
            newResponseType: ko.observable(),
            ResponseTypeList: ko.observableArray([]),
            openResponseTypePopUp: openResponseTypePopUp,
            getAllResponseTypes: getAllResponseTypes,
            addResponseType: addResponseType,
            updateResponseType: updateResponseType,
            deleteResponseType: deleteResponseType,

            FactorLanguageFlag: ko.observable(),
            SubFactorLanguageFlag: ko.observable(),
            hasChildNodes: ko.observable(false),
            AreaLeveljstree: ko.observableArray([]),
            NavigationMenuHideShow: NavigationMenuHideShow,
            CollapseAllTreeView: CollapseAllTreeView,
        };

        return RiskFactorSetupVM;

        var RiskFactorsTableObj = false;
        var ResponseTableObj = false;

        function attached() {
            try {
                if (RiskFactorSetupVM.ObjGeneralSettings === undefined || RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList() === undefined || ((RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList() !== undefined || RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList() !== null) && RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    RiskFactorSetupVM.ObjGeneralSettings.GetcLocalizedData().then(function () {
                        RiskFactorSetupVM.SurveyTitle((RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList() == undefined || RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList() == null || RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || RiskFactorSetupVM.ObjGeneralSettings.LocalizedIndexList() == undefined || RiskFactorSetupVM.ObjGeneralSettings.LocalizedIndexList() == null || RiskFactorSetupVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PCS') == -1) ? 'PCS' : RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList()[RiskFactorSetupVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PCS')].Name());
                    });
                }
                else
                    RiskFactorSetupVM.SurveyTitle((RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList() == undefined || RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList() == null || RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || RiskFactorSetupVM.ObjGeneralSettings.LocalizedIndexList() == undefined || RiskFactorSetupVM.ObjGeneralSettings.LocalizedIndexList() == null || RiskFactorSetupVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PCS') == -1) ? 'PCS' : RiskFactorSetupVM.ObjGeneralSettings.LocalizedTextList()[RiskFactorSetupVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PCS')].Name());

                GetAssessmentTypes();
                RiskFactorsTableObj = $('#riskFactorsTable').DataTable({ "bVisible": false });
                $('#riskFactorsTable').on('page.dt', function (event) {
                    checkExpandedRow("", true);
                    RiskFactorSetupVM.CurrentPageNumber(RiskFactorsTableObj.page());
                });
                InitiateLevelTree();
               // GetRRAreas();
                getAllResponseTypes();
                getLanguages();
                GetAllInherentLevels();
                GetAllOptionsType();
              

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in RiskRatingFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        //#region MRRArea Methods

        function GetRRAreas(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetRRAreas",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                RiskFactorSetupVM.RRAreaList(jsonResult);
                                $('#loadingMainImgDiv').show();
                                $('#RRAreasTab').tabs();
                                $('#RRAreasTab').tabs('refresh');
                                $('#RRAreasTab').tabs({ active: 0 });
                                $($('#RRAreasTabsUL li').get(0)).trigger('click');
                                scrollableTabs();
                            }
                            if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                                $('#errorAreas').show();
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while fetching the Risk Rating Areas. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Risk Rating Areas. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllRRAreas() method in RiskRatingFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        function GetAssessmentTypes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetAssessmentTypes",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                var mappedAssessmentList = $.map(jsonResult, function (result) {
                                    return new AssessmentListModel(result);
                                });
                               
                                RiskFactorSetupVM.AssessmentTypeList(mappedAssessmentList);                      
                                $('#RAApplicability').multiselect();
                            }
                            if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                                $('#errorAreas').show();
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while deleting the assessment type. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAssessmentTypes() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }
        function GetCopyOverAreas(data) {
            try {
                GetRRCopyAreas(data);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetCopyOverAreas() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function NavigationMenuHideShow(data) {
            try {
                if (data == "Hide") {
                    // Hides Area NavigationMenu
                    $('#HideNavMenu').hide();
                    $('#ShowNavMenu').show();
                    $('#FilterAreaAccordion').hide();
                    $("#bottomDivAreaType").removeClass("col-lg-9").addClass("col-lg-12");
                    // $(".rabrd").addClass("raBreadcrumb");

                }
                else {
                    // Shows Area NavigationMenu
                    $('#HideNavMenu').show();
                    $('#ShowNavMenu').hide();
                    $('#FilterAreaAccordion').show();
                    $("#bottomDivAreaType").removeClass("col-lg-12").addClass("col-lg-9");
                    // $(".rabrd").removeClass("raBreadcrumb");
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in NavigationMenuHideShow() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == "Expand") {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text("Collapse");
                $("#arrowSpan").removeClass("fa-caret-right").addClass("fa-caret-down");
            }
            else {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text("Expand");
                $("#arrowSpan").removeClass("fa-caret-down").addClass("fa-caret-right");

            }
        }


        function RRAreaTabClick(data, event) {
            try {
                $('#loadingMainImgDiv').show();
                $('#riskFactorsContent').hide();
                RiskFactorSetupVM.SelectedMRRAreaId(data.MRRAId);
                var mappedList = $.map(data.RATArray, function (result) {
                    return AssessmentListModel(result);
                });
                RiskFactorSetupVM.AssessmentTypeList(data.RATArray);

                //$('#lblRRAName').empty();
                //document.getElementById('lblRRAName').innerHTML = data.MRRAName;
                //$('#lblApplicability').empty();
                //document.getElementById('lblApplicability').innerHTML = data.ApplicableRATNames;

                getAllRiskFactors();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRAreaTabClick() method in RiskRatingFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Languages Methods
        
        function getLanguages() {
            RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
            RiskFactorSetupVM.languageList = RiskFactorSetupVM.ObjGeneralSettings.LanguageList();
            if (RiskFactorSetupVM.languageList[0].LANGUAGE_ID._latestValue == 1) {
                RiskFactorSetupVM.languageList.splice(0, 1);
            }
        }

        function getLanguageName(languageId) {
            if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length == 0) {
                RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
            }

            for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID().toString() === languageId.toString()) {
                    return RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME();
                }
            }

            return '';
        }

        //#endregion

        //#region Factor Methods

        //#region GetFactors

        function getAllRiskFactors() {
            try {
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetRiskFactors",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "SelectedMRRAreaId": RiskFactorSetupVM.SelectedMRRAreaId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getAllRiskFactors() method in RiskRatingFactorSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#loadingMainImgDiv').hide();
                    $('#riskFactorsContent').show();

                    if (jsonResult) {
                        if (RiskFactorSetupVM.RiskFactorList().length > 0) {
                            checkExpandedRow("", true);
                        }
                        RiskFactorSetupVM.RiskFactorList([]);

                        RiskFactorsTableObj.clear().destroy();
                        $('#riskFactorsTable tbody tr').remove();

                        var factorList = $.map(jsonResult, function (result) {
                            return new RRFactorModel(result);
                        });

                        RiskFactorSetupVM.RiskFactorList(factorList);


                        RiskFactorsTableObj = undefined;
                        RiskFactorsTableObj = $('#riskFactorsTable').DataTable({
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSortable": false
                            }, {
                                "aTargets": [6],
                                "bSortable": false,
                                "sClass": "text-center"
                            }]
                        });

                        $('#riskFactorsTable').DataTable().draw(false);
                        RiskFactorSetupVM.CurrentPageNumber(RiskFactorsTableObj.page());
                        if (jsonResult.length === 0) {
                            checkExpandedRow("", true);
                        }
                    }
                    else {
                        logger.logError('An error occurred while fetching the Risk Factors.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllRiskFactors() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK") {
                                    navigation.unauthorized();
                                }
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllRiskFactors() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllRiskFactors() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                  
                }
            }
        }
            //#endregion

            //#region Add, Edit, Save Factor - PopUps & Methods

            function AddFactorPopup(data) {
                try {
                    RiskFactorSetupVM.factorLanguageList([]);
                    RiskFactorSetupVM.SelectedAssessmentTypeFactor([]);
                    RiskFactorSetupVM.selectedLanguagesForFactor([]);

                    RiskFactorSetupVM.AddFactorFlag(true);
                    RiskFactorSetupVM.FactorLanguageFlag(false);
                    RiskFactorSetupVM.SubFactorLanguageFlag(false);
                    RiskFactorSetupVM.ResponseOptionList([]);
                    RiskFactorSetupVM.SelectedCopyAreas([]);
                    RiskFactorSetupVM.CopyAreasList([]);


                    if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length === 0) {
                        RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
                    }

                    RiskFactorSetupVM.languageList = RiskFactorSetupVM.ObjGeneralSettings.LanguageList();
                    if (RiskFactorSetupVM.languageList[0].LANGUAGE_ID._latestValue === 1) {
                        RiskFactorSetupVM.languageList.splice(0, 1);
                    }

                    var newFactor = new RRFactorModel({ RRFactorName: "", LanguageData: [], WantsAutoHigh: false});
                    RiskFactorSetupVM.selectedFactor(newFactor);

                    $('#AreaApplicabilityDiv').empty();
                    document.getElementById('AreaApplicabilityDiv').innerHTML = RiskFactorSetupVM.SelectedAreaName();

                    RiskFactorSetupVM.FactorPopUpTitle("Add Factor");
                    RiskFactorSetupVM.FactorPopUpType("Add");
                    RiskFactorSetupVM.selectedLanguageFactorType([]);
                    RiskFactorSetupVM.selectedResponseTypeFactor([]);
                    RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor([]);
                    RiskFactorSetupVM.selectedQuestionResponses('');

                    $('#FactorDescription').attr('placeholder', 'Risk Factor Description');
                    //$("#ParentResponseDropDown").multiselect('refresh');
                    $('#FactorRespTypeID').multiselect();
                    $('#factorLanguages').multiselect();
                    $('#AssessmentTypeMultiselect').multiselect();
                    //  $('#AssessmentTypeMultiselect').show();
                    $('#RFPopUp').modal('show');
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: AddFactorPopup() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function EditFactorPopup(data) {
                try {
                    RiskFactorSetupVM.selectedFactor(new RRFactorModel({ LanguageData: [] }));
                    RiskFactorSetupVM.AddFactorFlag(false);
                    RiskFactorSetupVM.FactorLanguageFlag(true);
                    RiskFactorSetupVM.SubFactorLanguageFlag(false);
                    RiskFactorSetupVM.ResponseOptionList(data.ResponseOptionTypeList);
                    RiskFactorSetupVM.FactorPopUpTitle("Edit Factor");
                    RiskFactorSetupVM.FactorPopUpType("Edit");
                    RiskFactorSetupVM.SelectedAssessmentTypeFactor(data.ApplicableRATIdsRRF());
                    var Obj = ko.toJS(data.LanguageData());
                    GetRRCopyAreas();
                    editFactorObject = new RRFactorModel({
                        RRFactorId: data.RRFactorId(), RRFactorName: data.RRFactorName(), RRFactorDescription: data.RRFactorDescription(),
                        RRFactorType: data.RRFactorType(), ConditionalParentId: data.ConditionalParentId(), ConditionalResponseIds: data.ConditionalResponseIds(),
                        ResponseTypeIds: data.ResponseTypeIds(), ResponseTypeNames: data.ResponseTypeNames(), RRFactorOverallRank: data.RRFactorOverallRank(),
                        ApplicableRATNamesRRF: data.ApplicableRATNamesRRF(), ApplicableRATIdsRRF: data.ApplicableRATIdsRRF(), RATArrayRRF: data.RATArrayRRF(),
                        ResponseTypesRRF: data.ResponseTypesRRF(), LanguageData: Obj, CopyOverAreas: data.CopyOverAreas(), CopyOverAreasNames: data.CopyOverAreasNames()
                        , WantsAutoHigh: data.WantsAutoHigh()
                    });

                    RiskFactorSetupVM.selectedFactor(editFactorObject);

                    var ATArray = [];
                    for (var i = 0; i < RiskFactorSetupVM.AssessmentTypeList().length; i++) {
                        var count = 0;
                        for (var j = 0; j < data.RATArrayRRF().length; j++) {
                            if (data.RATArrayRRF()[j].AssessmentId.toString().trim() === RiskFactorSetupVM.AssessmentTypeList()[i].AssessmentId().toString().trim())
                                count++;
                        }
                        if (count === 0)
                            ATArray.push(RiskFactorSetupVM.AssessmentTypeList()[i]);
                    }
                    if (ATArray.length === 0) {
                        $('#AssessmentTypeMultiselectEdit').hide();
                    }
                    else {
                        $('#AssessmentTypeMultiselectEdit').show();
                        $('#AssessmentTypeMultiselect').hide();
                        RiskFactorSetupVM.AssessmentTypeListEdit(ATArray);
                        $('#AssessmentTypeMultiselectEdit').multiselect();
                    }

                    $('#responseTypesForEdit').empty();

                    document.getElementById('responseTypesForEdit').innerHTML = data.ResponseTypeNames();


                    $('#assessmentTypesForEdit').empty();
                    document.getElementById('assessmentTypesForEdit').innerHTML = data.ApplicableRATNamesRRF();

                    $('#AreaApplicabilityDiv').empty();
                    document.getElementById('AreaApplicabilityDiv').innerHTML = data.CopyOverAreasNames();
                    var selectedAreas = [];

                    if (data.CopyOverAreas() != undefined)
                        selectedAreas = data.CopyOverAreas().trim().split(',');

                    var FilteredAreaList = [];

                    RiskFactorSetupVM.CopyAreasListEdit([]);

                    if (RiskFactorSetupVM.AddFactorFlag() == false) {
                        for (var copy = 0; copy < RiskFactorSetupVM.CopyAreasList().length; copy++) {

                            if (selectedAreas.toString().indexOf(RiskFactorSetupVM.CopyAreasList()[copy].MRRAId().toString().trim()) < 0) {

                                RiskFactorSetupVM.CopyAreasListEdit.push(RiskFactorSetupVM.CopyAreasList()[copy]);
                            }

                        }
                    }
                    //for (var sel = 0; sel < selectedAreas.length; sel++) {
                    //    if (selectedAreas[sel].trim() != RiskFactorSetupVM.CopyAreasList()[i].MRRAId()) {
                    //        RiskFactorSetupVM.CopyAreasListEdit.push(RiskFactorSetupVM.CopyAreasList()[i]);
                    //    }
                    //}


                    else {

                        for (var i = 0; i < RiskFactorSetupVM.CopyAreasList().length; i++) {
                            if (selectedAreas.trim() != RiskFactorSetupVM.CopyAreasList()[i].MRRAId) {
                                RiskFactorSetupVM.CopyAreasListEdit.push(RiskFactorSetupVM.CopyAreasList()[i]);
                            }
                        }

                    }
                    $('#copyareasMultiselectEdit').multiselect();
                    $('#copyareasMultiselectEdit').multiselect('refresh');

                    $('#RFPopUp').modal('show');
                    if (Obj.length > 0)
                        $("#factorsFormScroll").css({ "height": "45rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                    else {

                        $("#factorsFormScroll").css({ "height": "33rem", "overflow-y": "auto", "overflow-x": "hidden" });
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: EditFactorPopup() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }
            //function changedResponseType() {
            //    try {
            //        RiskFactorSetupVM.ResponseOptionList([]);
            //        for (var i = 0; i < RiskFactorSetupVM.selectedResponseTypeFactor().length; i++) {
            //            for (var j = 0; j < RiskFactorSetupVM.ResponseTypeList().length; j++) {
            //                if (RiskFactorSetupVM.selectedResponseTypeFactor()[i] == RiskFactorSetupVM.ResponseTypeList()[j].RRResponseTypeId) {
            //                    RiskFactorSetupVM.ResponseOptionList.push(new ResponseOptionModel({ "ResponseTypeId": RiskFactorSetupVM.ResponseTypeList()[j].RRResponseTypeId, "ResponseTypeName": RiskFactorSetupVM.ResponseTypeList()[j].RRResponseTypeName, "OptionTypeShortName": "" }));
            //                }
            //            }
            //        }
            //    }
            //    catch (e) {
            //        var msg = 'Exception: ' + e + ' | Source: ajaxFail in changedResponseType() method in QualitativeSetup.js';
            //        logger.logMessage(msg);
            //    }
            //}

            function GetAllOptionsType() {
                try {
                    $.ajax({
                        url: "/api/Configuration/GetAllOptionsType",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    })
                        .success(function (jsonResult, error) {
                            RiskFactorSetupVM.OptionsTypeList([]);
                            if (jsonResult != null) {
                                RiskFactorSetupVM.OptionsTypeList(jsonResult);
                            }
                        })
                        .fail(function (jsonResult, error) {
                            logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(AMLQsViewModel), true);
                        });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: GetAllOptionsType() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            }

            function saveRiskFactor(data, event) {
                try {
                    $('#errorMessageFactor').hide();
                    if (data.RRFactorName() === "") {
                        $('#errorMessageFactor').show();
                        $('#errorMessageFactor').text('Factor Name cannot be empty.');
                        return;
                    }

                    else if (RiskFactorSetupVM.AddFactorFlag() && RiskFactorSetupVM.SelectedAssessmentTypeFactor().length === 0) {
                        $('#errorMessageFactor').show();
                        $('#errorMessageFactor').text('Please select atleast one Assessment Type.');
                        return;
                    }

                    else if (RiskFactorSetupVM.AddFactorFlag() && RiskFactorSetupVM.selectedResponseTypeFactor().length === 0) {
                        $('#errorMessageFactor').show();
                        $('#errorMessageFactor').text('Please select atleast one Response Type');
                        return;
                    }

                    if (RiskFactorSetupVM.AddFactorFlag())
                        addRiskFactor(data);
                    else
                        editRiskFactor(data);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: saveRiskFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ResponseOptionModel(item) {
                try {
                    var self = this;
                    self.ResponseTypeId = ko.observable(item.ResponseTypeId);
                    self.ResponseTypeName = ko.observable(item.ResponseTypeName);
                    self.OptionTypeShortName = ko.observable(item.OptionTypeShortName);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            }
            function addRiskFactor(data) {
                try {
                    var selectedResponseTypes = "";
                    for (var i = 0; i < RiskFactorSetupVM.selectedResponseTypeFactor().length; i++) {
                        if (selectedResponseTypes === "")
                            selectedResponseTypes += RiskFactorSetupVM.selectedResponseTypeFactor()[i];
                        else
                            selectedResponseTypes += "," + RiskFactorSetupVM.selectedResponseTypeFactor()[i];
                    }

                    var selectedAssesmentTypes = "";
                    for (var i = 0; i < RiskFactorSetupVM.SelectedAssessmentTypeFactor().length; i++) {
                        if (selectedAssesmentTypes === "")
                            selectedAssesmentTypes += RiskFactorSetupVM.SelectedAssessmentTypeFactor()[i];
                        else
                            selectedAssesmentTypes += "," + RiskFactorSetupVM.SelectedAssessmentTypeFactor()[i];
                    }
                    var selectedcopyareas = "";
                    selectedcopyareas += RiskFactorSetupVM.SelectedMRRAreaId();
                    for (var i = 0; i < RiskFactorSetupVM.SelectedCopyAreas().length; i++) {
                        if (selectedcopyareas === "")
                            selectedcopyareas += RiskFactorSetupVM.SelectedCopyAreas()[i];
                        else
                            selectedcopyareas += "," + RiskFactorSetupVM.SelectedCopyAreas()[i];
                    }



                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/AddRiskFactor",
                        type: "POST",
                        headers: headers,
                        data: {
                            RRFactorName: data.RRFactorName(), RRFactorDescription: data.RRFactorDescription(),
                            ApplicableRATIdsRRF: selectedAssesmentTypes, ResponseTypeIds: selectedResponseTypes,
                            RRcopyareas: selectedcopyareas, ResponseOptionTypeModelObject: RiskFactorSetupVM.ResponseOptionList(),
                            WantsAutoHigh: data.WantsAutoHigh()
                        }
                    })
                        .success(function (jsonResult, success) {

                            if (jsonResult === 1) {
                                logger.logSuccess('Risk Factor has been added Successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                                $('#RFPopUp').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                getAllRiskFactors();
                            }
                            else
                                logger.logError('An error occurred while adding the Risk Factor. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        })
                        .fail(function (error, status) {
                            if (error.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK") {
                                            navigation.unauthorized();
                                        }
                                    });
                            } else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addRiskFactor() method in RiskRatingFactorSetup.js';
                                logger.logMessage(msg);
                            }
                        });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: addRiskFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function editRiskFactor(data) {
                try {

                    var selectedAssesmentTypes = data.ApplicableRATIdsRRF();;
                    for (var i = 0; i < RiskFactorSetupVM.SelectedAssessmentTypeFactor().length; i++) {
                        if (selectedAssesmentTypes === "")
                            selectedAssesmentTypes += RiskFactorSetupVM.SelectedAssessmentTypeFactor()[i];
                        else
                            selectedAssesmentTypes += "," + RiskFactorSetupVM.SelectedAssessmentTypeFactor()[i];
                    }

                    var MappedCopyOverAreas = "";
                    var ArrayCopyOverAreas = data.CopyOverAreas().split(',');
                    for (var i = 0; i < ArrayCopyOverAreas.length; i++) {
                        if (ArrayCopyOverAreas[i] != data.RiskAreaId) {
                            if (MappedCopyOverAreas == "")
                                MappedCopyOverAreas += MappedCopyOverAreas + ArrayCopyOverAreas[i];
                            else
                                MappedCopyOverAreas += "," + ArrayCopyOverAreas[i];
                        }
                    }
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/EditRiskFactor",
                        type: "POST",
                        headers: headers,
                        data: {
                            RRFactorId: data.RRFactorId(), RRFactorName: data.RRFactorName(), RRFactorDescription: data.RRFactorDescription(),
                            ApplicableRATIdsRRF: selectedAssesmentTypes, LanguageData: data.LanguageData(), CopyOverAreas: MappedCopyOverAreas
                            , WantsAutoHigh: data.WantsAutoHigh()
                        }
                    })
                        .success(function (jsonResult, success) {

                            if (jsonResult === 1) {
                                logger.logSuccess('Risk Factor has been edited Successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                                $('#RFPopUp').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                getAllRiskFactors();
                            }
                            else
                                logger.logError('An error occurred while editing the Risk Factor. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        })
                        .fail(function (error, status) {
                            if (error.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK") {
                                            navigation.unauthorized();
                                        }
                                    });
                            } else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in editRiskFactor() method in RiskRatingFactorSetup.js';
                                logger.logMessage(msg);
                            }
                        });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: editRiskFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            //#endregion

            //#region Factor - Languages Methods

            function FactorLanguageAdded() {
                try {
                    var selectedLanguage = RiskFactorSetupVM.selectedLanguagesForFactor();
                    $('#DynamicRiskFactorDiv').empty();

                    var additionalLanguagesHTML = "";
                    for (var j = 0; j < selectedLanguage.length; j++) {
                        for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                            if (parseInt(selectedLanguage[j]) === RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                                additionalLanguagesHTML +=
                                    '<div class="form-group">' +
                                    '<label class="col-xs-4 control-label">Risk Factor Name (' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                                    '<div class="col-xs-6">' +
                                    '<input id="factor' + selectedLanguage[j] + '" class="form-control" placeholder="Risk Factor in ' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + '" data-bind="value: factorLanguageList().LanguageFactorName" type="text" />' +
                                    '</div>' +
                                    '</div>';

                                additionalLanguagesHTML +=
                                    '<div class="form-group">' +
                                    '<label class="col-xs-4 control-label">Risk Factor Description (' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                                    '<div class="col-xs-6">' +
                                    '<textarea id="factorDescription' + selectedLanguage[j] + '" class="form-control" placeholder ="Risk Factor Description in ' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + '" rows="5" data-bind="value: factorLanguageList().LanguageFactorDescription"></textarea>' +
                                    '</div>' +
                                    '</div>';
                            }
                        }
                    }

                    document.getElementById('DynamicRiskFactorDiv').innerHTML = additionalLanguagesHTML;
                    ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
                    ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicRiskFactorDiv"));

                    if (additionalLanguagesHTML !== "") {
                        $("#subFactorResponseFormScroll").css({ "height": "35em", "overflow-y": "scroll", "overflow-x": "hidden" });
                        $("#factorsFormScroll").css({ "height": "45rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                    } else {
                        if (RiskFactorSetupVM.isHeaderFactorSelected())
                            $("#factorsFormScroll").css({ "height": "37rem", "overflow-y": "hidden", "overflow-x": "hidden" });
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: subFactorLangageAdded() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            //#endregion

            //#region Question Type related Methods

            function questionTypeChangedFactor(data, event) {
                try {
                    RiskFactorSetupVM.isReadOnlyFactorSelected(false);
                    RiskFactorSetupVM.isHeaderFactorSelected(false);
                    RiskFactorSetupVM.isConditionalFactorSelected(false);
                    document.getElementById("ReadOnlyTypeFactor").checked = false;
                    document.getElementById("HeaderTypeFactor").checked = false;
                    document.getElementById("ConditionalTypeFactor").checked = false;
                    document.getElementById(event.currentTarget.id).checked = true;
                    $('#FactorRespTypeID').multiselect();

                    if (event.currentTarget.value == "ReadOnlyTypeFactor") {
                        RiskFactorSetupVM.isReadOnlyFactorSelected(true);
                        $("#factorsFormScroll").css({ "height": "45rem", "overflow-y": "auto", "overflow-x": "hidden" });
                    } else if (event.currentTarget.value == "HeaderTypeFactor") {
                        RiskFactorSetupVM.isHeaderFactorSelected(true);
                        RiskFactorSetupVM.selectedResponseTypeFactor([]);
                        if ($("#factorLanguages :selected").length > 0)
                            $("#factorsFormScroll").css({ "height": "45rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                        else
                            $("#factorsFormScroll").css({ "height": "37rem", "overflow-y": "hidden", "overflow-x": "hidden" });
                    } else if (event.currentTarget.value == "ConditionalTypeFactor") {
                        RiskFactorSetupVM.isConditionalFactorSelected(true);
                        PopulateParentQuestionAndResponseDropdowns();

                        $("#factorsFormScroll").css({ "height": "45rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                        $("#ParentResponseDropDown").multiselect();
                    }

                    return true;
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: QuestionTypeChangedFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function resetRadioButtons(data, event) {
                try {
                    RiskFactorSetupVM.isReadOnlyFactorSelected(false);
                    RiskFactorSetupVM.isHeaderFactorSelected(false);
                    RiskFactorSetupVM.isConditionalFactorSelected(false);
                    document.getElementById("ReadOnlyTypeFactor").checked = false;
                    document.getElementById("HeaderTypeFactor").checked = false;
                    document.getElementById("ConditionalTypeFactor").checked = false;
                    $('#FactorRespTypeID').multiselect();
                    $("#factorsFormScroll").css({ "height": "45rem", "overflow-y": "auto", "overflow-x": "hidden" });
                    $('#errorMessageFactor').hide();
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: resetRadioButtons() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function parentQuestionChanged() {
                try {
                    $("#ParentQuestionLabel").html($("#ParentQuestionDropDown :selected").text());

                    var value = $('#ParentQuestionDropDown').val();
                    RiskFactorSetupVM.SelectedFactorId(value);
                    if (value) {
                        // For Parent Response Dropdown
                        getFactorsResponses(value).then(function () {
                            if (RiskFactorSetupVM.questionResponses().length === 0) {
                                $('#errMessageForQR-wrapper').show();
                                $('#ParentResponseDropDown-wrapper').hide();
                                $('#errMessageForQR').text('This Question does not have any Responses.');
                            }
                            else {
                                $('#errMessageForQR-wrapper').hide();
                                $('#ParentResponseDropDown-wrapper').show();
                                $('#errMessageForQR').text('');
                            }
                        });
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ParentQuestionChanged() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function PopulateParentQuestionAndResponseDropdowns() {
                try {
                    if (RiskFactorSetupVM.RiskFactorList().length == 0) {
                        getAllRiskFactors();
                    }
                    $("#ParentQuestionLabel").html($("#ParentQuestionDropDown :selected").text());

                    if ($('#ParentQuestionDropDown').text() !== "" && $('#ParentQuestionDropDown').text() !== undefined) {
                        RiskFactorSetupVM.questionResponses([]);
                        parentQuestionChanged();
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: PopulateParentQuestionAndResponseDropdowns() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            //#endregion

            //#region Delete Factor Methods

            function onDeleteFactor(data, event) {
                try {
                    app.showMessage('Are you sure you want to delete this Factor?', 'Delete Factor', ['Confirm', 'Cancel'])
                        .then(function (option) {
                            if (option === 'Confirm') {
                                deleteFactor(data.RRFactorId());
                            }
                        });

                    setTimeout(function () {
                        $(event.target).focus();
                    }, 1);
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    return false;
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: deleteResponseType() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function deleteFactor(RRFactorId) {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/DeleteRiskFactor?RiskFactorId=" + RRFactorId + "&AreaId=" + RiskFactorSetupVM.SelectedMRRAreaId(),
                        type: "POST",
                        headers: headers
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in deleteFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, status) {
                    try {
                        if (jsonResult > 0) {
                            logger.logSuccess('Risk Factor has been deleted Successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                            getAllRiskFactors();
                        }
                        else
                            logger.logError('An error occurred while deleting the Risk Factor.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteFactor() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        }
                        else
                            logger.logError('An error occurred while deleting the Risk Factor. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteFactor() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }
            }

            //#endregion

            //#region NavigationMenu
            function InitiateLevelTree() {
                try {

                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    getJsTreeAreaLevel = {

                        url: "/api/RiskRatingConfiguration/GetAllAreasForRR",
                        type: "GET",
                        headers: headers
                    };
                    $.ajax(getJsTreeAreaLevel)
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, status) {
                    if (jsonResult != null) {
                        if (jsonResult.AreaLevelsData["#"] == undefined) {
                            $('#riskFactorsTable').hide();
                            $('#FilterAreaAccordion').hide();
                            $('#ConfigButtons').hide();
                            $('#error').show();

                        }
                        else {
                            $('#error').hide();
                            $('#riskFactorsTable').show();
                            $('#FilterAreaAccordion').show();
                           $('#ConfigButtons').show();
                            //implement js tree logic here
                            RiskFactorSetupVM.AreaLeveljstree(jsonResult.AreaLevelsData);

                            var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                                return new jsTreeModel(result);
                            });


                            $('#jsTreeAreaLevel').treeview({
                                data: MappedJsTreeList,
                                onNodeSelected: nodeClickEvent
                            });

                            var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                            RiskFactorSetupVM.hasChildNodes(hasChildNodes);

                            //for initial load expand for treeview
                            $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                            $("loadingImgOrCalc").hide();
                            $("loadingMainImgDivTh").hide();
                            $("loadingImgMainTh").hide();
                        }
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }
                }

                function filterJsTree(TreeStructure) {

                    return TreeStructure.filter(
                        function (item) {
                            if (item.nodes != undefined && item.nodes.length > 0) {
                                item.nodes = filterJsTree(item.nodes);
                            }

                            if (item.showLevel == 1)
                                return true;
                            else
                                return false;

                        }
                    );
                }


                function nodeClickEvent(event, node) {

                    // Your logic goes here
                    if (node.dead_node == 1) {
                        //select node explicitly in case of recursive calling activity.
                        $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);


                        RiskFactorSetupVM.SelectedMRRAreaId(parseInt(node.id));
                        getAllRiskFactors();
                        $('#loadingMainImgDivFactors').show();
                        //GetRiskSubFactors(parseInt(node.id));
                        RiskFactorSetupVM.SelectedAreaName(node.text);

                    } else {
                        //recursively opening until the dead_node arrives.
                        if (!(node.state.expanded))
                            nodeClickEvent(event, node.nodes[0]);
                        $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                        $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);


                    }
                }


                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                };
            }
            //#endregion



            //#region Factor RowExpandClick Methods

            function checkExpandedRow(row, isPaginating) {
                try {
                    var currentRowIndex;
                    var rowsInTable = $('#riskFactorsTable').find('tr');
                    if (isPaginating) {
                        currentRowIndex = -1;
                    } else {
                        currentRowIndex = row.index();
                    }

                    var info = RiskFactorsTableObj.page.info();
                    for (var i = 1, j = rowsInTable.length; i < j; i++) {
                        var tr = $('#riskFactorsTable').find('tr').get(i);
                        if (RiskFactorsTableObj.row(tr).index() != currentRowIndex) {
                            var tableRowIndex = 0;
                            if (isPaginating) {
                                tableRowIndex = (RiskFactorSetupVM.CurrentPageNumber() * info.length) + (i - 1);
                            } else {
                                tableRowIndex = (info.page * info.length) + (i - 1);
                            }

                            if ((RiskFactorsTableObj.row(tableRowIndex).child() != undefined)
                                && (RiskFactorsTableObj.row(tableRowIndex).child.isShown())) {
                                RiskFactorsTableObj.row(tableRowIndex).child.remove();
                                tr.removeAttribute('class', 'shown');
                                j = $('#riskFactorsTable').find('tr').length;
                            }
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function rowExpandClick(data, event) {
                try {
                    var tr = $(event.currentTarget).closest('tr');
                    var row = RiskFactorsTableObj.row(tr);

                    RiskFactorSetupVM.SelectedResponseRow([]);
                    RiskFactorSetupVM.SelectedResponseRow.push(tr);
                    RiskFactorSetupVM.SelectedResponseRow.push(data);
                    checkExpandedRow(row, false);
                    RiskFactorSetupVM.ClickedFactorID(data.RRFactorId());
                    var RATArray = ko.toJS(data.RATArrayRRF());
                    RiskFactorSetupVM.SubFactorAssessmentTypeList(RATArray);

                    var Responses = ko.toJS(data.ResponseTypesRRF());
                    RiskFactorSetupVM.currentSubFactorResponseTypes(Responses);

                    RiskFactorSetupVM.SelectedFactorId(data.RRFactorId());

                    if (row.child.isShown()) {
                        row.child.hide();
                        tr.removeClass('shown');
                        ResponseTableObj = false;
                        RiskFactorSetupVM.SubFactorAssessmentTypeList([]);
                        RiskFactorSetupVM.currentSubFactorResponseTypes([]);
                    } else {
                        getFactorsResponses(data).then(function () {
                            createResponsesTable(RiskFactorSetupVM.SelectedResponseRow());

                        });
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: rowExpandClick() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function createResponsesTable(param) {
                try {
                    var tr = param[0];
                    var row = RiskFactorsTableObj.row(tr);
                    row.child("");
                    row.child(format(row.data())).show();
                    tr.addClass('shown');

                    ko.applyBindingsToNode($('#factorResponseTable tbody').get(0), {
                        foreach: RiskFactorSetupVM.FactorResponsesList()
                    }, RiskFactorSetupVM);

                    ko.applyBindingsToNode($('#btnAddResponse').get(0), {
                        click: RiskFactorSetupVM.addSubFactorClick
                    }, param[1]);

                    ResponseTableObj = $('#factorResponseTable').DataTable({
                        "bResponsive": true,
                        "bPaginate": true,
                        "aoColumnDefs": [{
                            "aTargets": [1],
                            "bVisible": false
                        }, {
                            "aTargets": [6],
                            "bSortable": false,
                            "sClass": "text-center",
                            "bVisible": true
                        }]
                    });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: createResponsesTable() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function format(data) {
                try {
                    var ResponseHtml =
                        '<div class="child-active" style="margin-left: 3em;">' +
                        '<div class="panel panel-success panel-margin">' +
                        '<div class="panel-heading">' +
                        '<h5 class="panel-title riskFactorCellPanel">Responses';

                    ResponseHtml +=
                        '<button id="btnAddResponse" class="btn btn-primary btn-xs pull-right addSubFactorBtn" data-bind="click: $root.addSubFactorClick.bind($data, \'\')" title="Click to Add New Response for the selected Risk Factor">' +
                        '<i class="fa fa-plus"></i> Add Response' +
                        '</button>';

                    ResponseHtml +=
                        '</h5>' +
                        '</div>' +
                        '</div>' +
                        '<div class="col-xs-12 subfactor-margin">' +
                        '<table id="factorResponseTable" class="dataTable table-bordered" cellspacing="0">' +
                        '<thead>' +
                        '<tr>' +
                        '<th style="padding: 5px 15px !important;; width: 100px;" class="text-center">Sequential Order Number</th>' +
                        '<th style="display: none">RRSubFactorId</th>' +
                        '<th>Response</th>' +
                        '<th>Applicability</th>' +
                        '<th>Response Types</th>' +
                        '<th>Score</th>' +
                        '<th class="actions">Actions</th>' +
                        '</tr>' +
                        '</thead>' +
                        '<tbody data-bind="foreach: FactorResponsesList">' +
                        '<tr>' +
                        '<td class="text-center" data-bind="text: RRSubFactorOverallRank"></td>' +
                        '<td style="display: none" data-bind="text: RRSubFactorId"></td>' +
                        '<td data-bind="text: RRSubFactorName"></td>' +
                        '<td data-bind="text: ApplicableRATNamesRRSF"></td>' +
                        '<td data-bind="text: ResponseTypeNamesRRSF"></td>' +
                        '<td data-bind="text: RATMapIRLName"></td>' +
                        '<td class="text-center">' +
                        '<a href="javascript:void(0)" title="Edit Response" class="btn-borderless widget-button" data-bind="click: $root.editSubFactorPopUp">' +
                        '<i class="deloitte-icon icon-file_edit_pos fafonticoncss text-success icon-bar"></i>' +
                        '</a>';
                    if (RiskFactorSetupVM.appsecurity.WriteAccess()) {
                        ResponseHtml += '<a href="javascript:void(0)" title="Delete Response" class="btn-borderless widget-button" data-bind="click: $root.onDeleteSubFactor">' +
                            '<i class="deloitte-icon icon-bin_pos fafonticoncss icon-bar text-danger"></i>' +
                            '</a>';
                    }
                    ResponseHtml +=  '</td>' +
                        '</tr>' +
                        '</tbody>' +
                        '</table>' +
                        '</div>';

                    return ResponseHtml;
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: Format() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            //#endregion

            //#endregion

            //#region SubFactors Methods

            //#region GetSubFactors

            function getFactorsResponses(data) {
                try {
                    // RiskFactorSetupVM.ClickedFactorID(data.RRFactorId());
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/RiskRatingConfiguration/GetRiskSubFactors?RiskFactorId=" + RiskFactorSetupVM.ClickedFactorID(),
                        type: "GET",
                        headers: headers
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in getFactorsResponses() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, error) {
                    try {
                        if (data && typeof data == 'object') {
                            RiskFactorSetupVM.FactorResponsesList([]);

                            if (jsonResult != null && jsonResult.length > 0) {

                                var responseList = $.map(jsonResult, function (result) {
                                    return new SubFactorModel(result);
                                });

                                RiskFactorSetupVM.FactorResponsesList(responseList);
                            }
                            else if (jsonResult == null) {
                                logger.logError('An error occurred while fetching the Responses for this Question.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                            }
                        } else {
                            RiskFactorSetupVM.questionResponses([]);

                            if (jsonResult != null && jsonResult.length > 0) {
                                RiskFactorSetupVM.questionResponses(jsonResult);
                                $("#ParentResponseDropDown").multiselect('refresh');
                            } else if (jsonResult == null) {
                                logger.logError('An error occurred while fetching the Responses for this Question.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                            }

                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getFactorsResponses() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getFactorsResponses() method in RiskRatingFactorSetup.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in getFactorsResponses() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                };
            }

            //#endregion

            //#region GetAllInherentLevels

            function GetAllInherentLevels() {
                try {
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/GetAllInherentLevels",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    })
                        .success(function (jsonResult, Error) {
                            var mappedIRSData = $.map(jsonResult, function (result) {
                                return new RiskLevelModel(result);
                            });
                            RiskFactorSetupVM.riskLevels(mappedIRSData);

                            var mappedIRSDataDup = $.map(jsonResult, function (result) {
                                return new RiskLevelModel(result);
                            });
                            RiskFactorSetupVM.riskLevelsDup(mappedIRSDataDup);
                        })
                        .fail(function (jsonResult, log) {
                            if (jsonResult.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            navigation.unauthorized();
                                    })
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllInherentLevels() method in RiskRatingFactorSetup.js';
                                logger.logMessage(msg);
                            }
                        });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: GetAllInherentLevels() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            //#endregion

            //#region  Add, Edit, Save SubFactor - PopUps & Methods

            function addSubFactorClick(data, event) {
                try {
                    $('#subFactorResponsePopup').modal('show');
                    RiskFactorSetupVM.selectedResponseTypeFactor([]);
                    RiskFactorSetupVM.selectedSubFactorResponseTypeFactor([]);
                    RiskFactorSetupVM.subFactorLanguageList([]);
                    RiskFactorSetupVM.AddSubFactorFlag(true);
                    RiskFactorSetupVM.FactorLanguageFlag(false);
                    RiskFactorSetupVM.SubFactorLanguageFlag(false);

                    RiskFactorSetupVM.ResponsePopUpTitle("Add Response");
                    RiskFactorSetupVM.ResponsePopUpType("Add");

                    var newResponse = new SubFactorModel({ RRSubFactorOverallRank: "", RRSubFactorName: "", LanguageDataRRSF: [], WantsAutoHighresponsesub : ""});
                    RiskFactorSetupVM.selectedSubFactor(newResponse);

                    // Languages
                    if (RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length === 0) {
                        RiskFactorSetupVM.ObjGeneralSettings.getLanguages();
                    }

                    RiskFactorSetupVM.languageList = RiskFactorSetupVM.ObjGeneralSettings.LanguageList();
                    if (RiskFactorSetupVM.languageList[0].LANGUAGE_ID._latestValue == 1) {
                        RiskFactorSetupVM.languageList.splice(0, 1);
                    }

                    RiskFactorSetupVM.selectedLanguagesForSubFactor([]);
                    RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor([]);


                    $('#subFactorResponseTypeSelect').multiselect();
                    $('#subFactorLanguages').multiselect();
                    $('#assTypesSubFactorMultiselect').multiselect();
                    setTimeout("$('#sequentialNumberInput').focus();", 200);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: AddResponsePopUp() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function editSubFactorPopUp(data, event) {
                try {
                    RiskFactorSetupVM.selectedSubFactor(new SubFactorModel({ LanguageDataRRSF: [] }));
                    RiskFactorSetupVM.ResponsePopUpTitle("Edit Response");
                    RiskFactorSetupVM.ResponsePopUpType("Edit");
                    RiskFactorSetupVM.AddSubFactorFlag(false);
                    RiskFactorSetupVM.FactorLanguageFlag(false);
                    RiskFactorSetupVM.SubFactorLanguageFlag(true);
                    RiskFactorSetupVM.subFactorLanguageList([]);
                    RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor([]);
                    var Obj = ko.toJS(data.LanguageDataRRSF());

                    editSubFactorObject = new SubFactorModel({
                        RRSubFactorId: data.RRSubFactorId(), RRSubFactorName: data.RRSubFactorName(), RRSubFactorDescription: data.RRSubFactorDescription(),
                        RATMapIRLId: data.RATMapIRLId(), RATMapIRLName: data.RATMapIRLName(), ResponseTypeIdsRRSF: data.ResponseTypeIdsRRSF(),
                        ResponseTypeNamesRRSF: data.ResponseTypeNamesRRSF(), RRSubFactorOverallRank: data.RRSubFactorOverallRank(),
                        ApplicableRATNamesRRSF: data.ApplicableRATNamesRRSF(), ApplicableRATIdsRRSF: data.ApplicableRATIdsRRSF(),
                        RATArrayRRSF: data.RATArrayRRSF(), LanguageDataRRSF: Obj
                        , RRSubAutoHighResp: data.RRSubAutoHighResp()
                        //, WantsAutoHighresponsesub: ""
                    });

                    RiskFactorSetupVM.selectedSubFactor(editSubFactorObject);

                    var ATArray = [];
                    for (var i = 0; i < RiskFactorSetupVM.SubFactorAssessmentTypeList().length; i++) {
                        var count = 0;
                        for (var j = 0; j < data.RATArrayRRSF().length; j++) {
                            if (data.RATArrayRRSF()[j].AssessmentId.toString().trim() === RiskFactorSetupVM.SubFactorAssessmentTypeList()[i].AssessmentId.toString().trim())
                                count++;
                        }
                        if (count === 0)
                            ATArray.push(RiskFactorSetupVM.SubFactorAssessmentTypeList()[i]);
                    }
                    if (ATArray.length === 0) {
                        $('#assTypesSubFactorMultiselectEdit').hide();
                    }
                    else {
                        $('#assTypesSubFactorMultiselectEdit').show();
                        RiskFactorSetupVM.SubFactorAssessmentTypeListEdit(ATArray);
                        $('#assTypesSubFactorMultiselectEdit').multiselect();
                    }
                    $('#assessmentTypesForEditForSubFactors').empty();
                    document.getElementById('assessmentTypesForEditForSubFactors').innerHTML = data.ApplicableRATNamesRRSF();

                    $('#responseTypesForEditForSubFactors').empty();
                    document.getElementById('responseTypesForEditForSubFactors').innerHTML = data.ResponseTypeNamesRRSF();

                    RiskFactorSetupVM.SelectedRATForSubFactorEdit(data.ApplicableRATIdsRRSF());

                    BindDynamicHtmlForDropDownsEdit(RiskFactorSetupVM.selectedSubFactor().RATMapIRLId().split('|'));
                    $('#subFactorResponsePopup').modal('show');
                    $('#subFactorResponseTypeSelect').multiselect();
                    $('#subFactorLanguages').hide();
                    setTimeout("$('#sequentialNumberInput').focus();", 200);
                    if (Obj.length > 0)
                        $("#subFactorResponseFormScroll").css({ "height": "35rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: editSubFactorPopUp() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function saveSubFactor(data, event) {
                try {
                    $('#errorMessageSubFactor').hide();
                    $('#errorMessageSubFactor').text('');

                    if (data.RRSubFactorOverallRank() === "") {
                        $('#errorMessageSubFactor').show();
                        $('#errorMessageSubFactor').text('Sequential Order Number can not be empty.');
                        return;
                    }

                    if (data.RRSubFactorName() === "") {
                        $('#errorMessageSubFactor').show();
                        $('#errorMessageSubFactor').text('Response cannot be empty.');
                        return;
                    }

                    else if (RiskFactorSetupVM.AddSubFactorFlag() && RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().length === 0) {
                        $('#errorMessageSubFactor').show();
                        $('#errorMessageSubFactor').text('Please select atleast one Assessment Type.');
                        return;
                    }

                    else if (RiskFactorSetupVM.AddSubFactorFlag() && RiskFactorSetupVM.selectedSubFactorResponseTypeFactor().length === 0) {
                        $('#errorMessageSubFactor').show();
                        $('#errorMessageSubFactor').text('Please select atleast one Response Type');
                        return;
                    }

                    // Languages
                    if (RiskFactorSetupVM.AddSubFactorFlag()) {
                        var LangArray = [];
                        for (var j = 0; j < RiskFactorSetupVM.selectedLanguagesForSubFactor().length; j++) {
                            for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                                if (parseInt(RiskFactorSetupVM.selectedLanguagesForSubFactor()[j]) == RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                                    selectedLanguageId = RiskFactorSetupVM.selectedLanguagesForSubFactor()[j];
                                    subfactorLanguageData = new RRLanguageDataModel({
                                        LanguageFactorName: $('#response' + selectedLanguageId).val(),
                                        LanguageId: selectedLanguageId
                                    });

                                    if ($('#response' + selectedLanguageId).val() === "") {
                                        $('#errorMessageSubFactor').show();
                                        $('#errorMessageSubFactor').text('Response in ' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' cannot be empty.');
                                        return;
                                    } else {
                                        $('#errorMessageSubFactor').hide();
                                        $('#errorMessageSubFactor').text('');
                                    }
                                    LangArray.push(subfactorLanguageData);
                                }
                            }
                        }
                        data.LanguageDataRRSF(LangArray);
                    }
                    if (!RiskFactorSetupVM.AddSubFactorFlag()) {
                        for (var i = 0; i < data.LanguageDataRRSF().length; i++) {
                            if (data.LanguageDataRRSF()[i].LanguageFactorName() === "") {
                                $('#errorMessageSubFactor').show();
                                $('#errorMessageSubFactor').text('Response in ' + getLanguageName(data.LanguageDataRRSF()[i].LanguageId()) + ' cannot be empty.');
                                return;
                            }
                        }
                    }

                    if (RiskFactorSetupVM.AddSubFactorFlag())
                        addSubFactor(data);
                    else
                        editSubFactor(data);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: saveSubFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function addSubFactor(data) {
                try {
                    var selectedResponseTypes = "";
                    for (var i = 0; i < RiskFactorSetupVM.selectedSubFactorResponseTypeFactor().length; i++) {
                        if (selectedResponseTypes === "")
                            selectedResponseTypes += RiskFactorSetupVM.selectedSubFactorResponseTypeFactor()[i];
                        else
                            selectedResponseTypes += "," + RiskFactorSetupVM.selectedSubFactorResponseTypeFactor()[i];
                    }

                    var selectedAssesmentTypes = "";
                    for (var i = 0; i < RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().length; i++) {
                        if (selectedAssesmentTypes === "")
                            selectedAssesmentTypes += RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i];
                        else
                            selectedAssesmentTypes += "," + RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i];
                    }

                    var RiskMapping = "";

                    for (var i = 0; i < RiskFactorSetupVM.riskLevels().length; i++) {
                        for (var j = 0; j < RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().length; j++) {
                            if (RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[j] === parseInt(RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId)) {
                                if (RiskMapping === "")
                                    RiskMapping += RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId + '-' + $('#' + RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId).val();
                                else
                                    RiskMapping += "|" + RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId + '-' + $('#' + RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId).val();
                            }
                        }
                    }

                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/AddRiskSubFactor?SelectedMRRAreaId=" + RiskFactorSetupVM.SelectedMRRAreaId() +
                            "&SelectedFactorId=" + RiskFactorSetupVM.ClickedFactorID(),
                        type: "POST",
                        headers: headers,
                        data: {
                            RRSubFactorName: data.RRSubFactorName(), RRSubFactorOverallRank: data.RRSubFactorOverallRank(),
                            ApplicableRATIdsRRSF: selectedAssesmentTypes, ResponseTypeIdsRRSF: selectedResponseTypes,
                            RATMapIRLId: RiskMapping,
                            RRSubAutoHighResp: data.RRSubAutoHighResp()
                        }
                    })
                        .success(function (jsonResult, success) {

                            if (jsonResult === 1) {
                                logger.logSuccess('Response has been added Successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                                $('#subFactorResponsePopup').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                getFactorsResponses(data).then(function () {
                                    createResponsesTable(RiskFactorSetupVM.SelectedResponseRow());
                                });
                            }
                            else
                                logger.logError('An error occurred while adding the Response. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        })
                        .fail(function (error, status) {
                            if (error.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK") {
                                            navigation.unauthorized();
                                        }
                                    });
                            } else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addSubFactor() method in RiskRatingFactorSetup.js';
                                logger.logMessage(msg);
                            }
                        });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: addSubFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function editSubFactor(data) {
                try {
                    var selectedAssesmentTypes = data.ApplicableRATIdsRRSF();
                    RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().sort();
                    for (var i = 0; i < RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor().length; i++) {
                        if (selectedAssesmentTypes === "")
                            selectedAssesmentTypes += RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i];
                        else
                            selectedAssesmentTypes += "," + RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor()[i];
                    }

                    var RiskMapping = "";

                    var RAT = [];
                    for (var i = 0; i < selectedAssesmentTypes.split(',').length; i++) {
                        RAT[i] = parseInt(selectedAssesmentTypes.split(',')[i].trim());
                    }

                    for (var i = 0; i < RiskFactorSetupVM.riskLevels().length; i++) {
                        for (var j = 0; j < RAT.length; j++) {
                            if (RAT[j] === parseInt(RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId)) {
                                if (RiskMapping === "")
                                    RiskMapping += RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId + '-' + $('#' + RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId).val();
                                else
                                    RiskMapping += "|" + RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId + '-' + $('#' + RiskFactorSetupVM.riskLevels()[i].AssessmentTypeId).val();
                            }
                        }
                    }

                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/EditRiskSubFactor",
                        type: "POST",
                        headers: headers,
                        data: {
                            RRSubFactorId: data.RRSubFactorId(), RRSubFactorName: data.RRSubFactorName(), RRSubFactorOverallRank: data.RRSubFactorOverallRank(),
                            ApplicableRATIdsRRSF: selectedAssesmentTypes, RATMapIRLId: RiskMapping, LanguageDataRRSF: data.LanguageDataRRSF()
                            , RRSubAutoHighResp: data.RRSubAutoHighResp()
                        }
                    })
                        .success(function (jsonResult, success) {

                            if (jsonResult === 1) {
                                logger.logSuccess('Response has been edited Successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                                $('#subFactorResponsePopup').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                getFactorsResponses(data).then(function () {
                                    createResponsesTable(RiskFactorSetupVM.SelectedResponseRow());
                                });
                            }
                            else
                                logger.logError('An error occurred while editing the Response. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        })
                        .fail(function (error, status) {
                            if (error.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK") {
                                            navigation.unauthorized();
                                        }
                                    });
                            } else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in editSubFactor() method in RiskRatingFactorSetup.js';
                                logger.logMessage(msg);
                            }
                        });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: editSubFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            //#endregion

            //#region SubFactors - Languages Methods

            function subFactorLangageAdded() {
                try {
                    var selectedLanguage = RiskFactorSetupVM.selectedLanguagesForSubFactor();
                    $('#DynamicResponseDiv').empty();

                    var additionalLanguagesHTML = "";
                    for (var j = 0; j < selectedLanguage.length; j++) {
                        for (var i = 0; i < RiskFactorSetupVM.ObjGeneralSettings.LanguageList().length; i++) {
                            if (parseInt(selectedLanguage[j]) == RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                                additionalLanguagesHTML +=
                                    '<div class="form-group">' +
                                    '<label class="col-xs-4 control-label">Response (' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                                    '<div class="col-xs-6">' +
                                    '<input id="response' + selectedLanguage[j] + '" class="form-control" placeholder="Response in ' + RiskFactorSetupVM.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: subFactorLanguageList().LanguageData" type="text" />' +
                                    '</div>' +
                                    '</div>';
                            }
                        }
                    }

                    document.getElementById('DynamicResponseDiv').innerHTML = additionalLanguagesHTML;
                    ko.cleanNode(document.getElementById('DynamicResponseDiv'));
                    ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicResponseDiv"));

                    if (additionalLanguagesHTML != "") {
                        $("#subFactorResponseFormScroll").css({ "height": "35em", "overflow-y": "scroll", "overflow-x": "hidden" });
                    } else {
                        $('#subFactorResponseFormScroll').removeAttr("style");
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: subFactorLangageAdded() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            //#endregion

            //#region Delete SubFactor Methods

            function onDeleteSubFactor(data, event) {
                try {
                    app.showMessage('Are you sure you want to delete this Factor?', 'Delete Factor', ['Confirm', 'Cancel'])
                        .then(function (option) {
                            if (option === 'Confirm') {
                                deleteSubFactor(data);
                            }
                        });

                    setTimeout(function () {
                        $(event.target).focus();
                    }, 1);
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    return false;
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: onDeleteSubFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function deleteSubFactor(data) {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/DeleteRiskSubFactor?SubFactorId=" + data.RRSubFactorId(),
                        type: "POST",
                        headers: headers
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in deleteSubFactor() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(result, status) {
                    try {
                        if (result > 0) {
                            logger.logSuccess('Response has been deleted Successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                            getFactorsResponses(data).then(function () {
                                createResponsesTable(RiskFactorSetupVM.SelectedResponseRow());
                            });
                        }
                        else {
                            logger.logError('An error occurred while deleting the Response.Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteSubFactor() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 409) {
                            logger.logError('You are not able to delete this Response, because it is used somewhere in the application.', 'Error', system.getModuleId(RiskFactorSetupVM), true);

                        } else if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteSubFactor() method in RiskRatingFactorSetup.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteSubFactor() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }
            }

            //#endregion

            //#region Risk Score Dynamic DropDown Methods

            function ActionChanged() {
                BindDynamicHtmlForDropDowns();
            }

            function BindDynamicHtmlForDropDowns() {
                try {
                    var selectedassessments = RiskFactorSetupVM.SelectedAssessmentTypesForSubFactor();
                    $('#DynamicScoreAddDiv').empty();
                    var DynamicHTMl = "";
                    for (var j = 0; j < selectedassessments.length; j++) {
                        for (var i = 0; i < RiskFactorSetupVM.AssessmentTypeList().length; i++) {
                            if (parseInt(selectedassessments[j].toString().trim()) == parseInt(RiskFactorSetupVM.AssessmentTypeList()[i].AssessmentId().toString().trim())) {

                                DynamicHTMl +=
                                    '<div class="form-group d-flex" id="appSubfactor">' +
                                    '<label class="col-lg-4 control-label">' + RiskFactorSetupVM.AssessmentTypeList()[i].AssessmentDisplayName() + ' Risk Score :</label>' +
                                    '<div class="col-lg-4 d-flex">' +
                                    '<select id="' + RiskFactorSetupVM.AssessmentTypeList()[i].AssessmentId() + '" data-bind="foreach: { data: riskLevels, as: \'List1\' }" class="form-control">' +
                                    '<!-- ko if: (List1.AssessmentTypeId == ' + selectedassessments[j].toString() + ' || List1.AssessmentTypeId == 99999)-->' +
                                    '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                                    '<option data-bind="text: RiskLevelDescription, value: RiskLevelId"></option>' +
                                    '</optgroup>' +
                                    '<!--/ko -->' +
                                    '</select>' +
                                    '</div>' +
                                    '</div>';
                            }
                        }
                    }
                    document.getElementById('DynamicScoreAddDiv').innerHTML = DynamicHTMl;
                    ko.cleanNode(document.getElementById('DynamicScoreAddDiv'));
                    ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicScoreAddDiv"));
                    $("#subFactorResponseFormScroll").css({ "height": "35rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDowns() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function BindDynamicHtmlForDropDownsEdit(data) {
                try {
                    var DynamicHTMl = "";
                    var arr = [];

                    for (var k = 0; k < data.length; k++) {
                        var splitID = data[k].split(',');

                        for (var g = 0; g < RiskFactorSetupVM.AssessmentTypeList().length; g++) {

                            if (parseInt(splitID[0].toString().trim()) === parseInt(RiskFactorSetupVM.AssessmentTypeList()[g].AssessmentId())) {
                                DynamicHTMl +=
                                    '<div class="form-group d-flex">' +
                                    '<label class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label">' + RiskFactorSetupVM.AssessmentTypeList()[g].AssessmentDisplayName() + ' Risk Level</label>' +
                                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                    '<!-- ko foreach: $root.riskLevels -->' +
                                    '<!-- ko if: (AssessmentTypeId ==' + splitID[0].toString().trim() + '|| AssessmentTypeId == 99999)-->' +
                                    '<select id="' + RiskFactorSetupVM.AssessmentTypeList()[g].AssessmentId() + '"data-bind="options: MappedRiskLevels, optionsText: \'RiskLevelDescription\', optionsValue: \'RiskLevelId\', value:' + splitID[1].toString().trim() + '" class="form-control"></select>' +
                                    '<!--/ko -->' +
                                    '<!--/ko -->' +
                                    '</div>' +
                                    '</div>';
                            }
                        }
                    }

                    document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl;
                    ko.cleanNode(document.getElementById('DynamicScoreDiv'));
                    ko.applyBindings(RiskFactorSetupVM, document.getElementById("DynamicScoreDiv"));
                    for (var k = 0; k < data.length; k++) {
                        var splitID = data[k].split(',');
                        $('#' + parseInt(splitID[1])).val(parseInt(splitID[0]));
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDownsEdit() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function GetRRCopyAreas(data) {
                try {

                    var RATIDs = "";
                    if (RiskFactorSetupVM.AddFactorFlag() == false) {
                        RATIDs = RiskFactorSetupVM.SelectedAssessmentTypeFactor();
                    }
                    else {
                        for (var i = 0; i < RiskFactorSetupVM.SelectedAssessmentTypeFactor().length; i++) {
                            if (RATIDs === "")
                                RATIDs += RiskFactorSetupVM.SelectedAssessmentTypeFactor()[i];
                            else
                                RATIDs += "," + RiskFactorSetupVM.SelectedAssessmentTypeFactor()[i];
                        }
                    }
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/GetRRCopyOverAreas",
                        type: "GET",
                        headers: headers,
                        data: { "SelectedRAT": RATIDs }
                    })
                        .success(function (jsonResult, error) {
                            if (jsonResult !== null) {
                                if (jsonResult.length > 0) {

                                    var mappedareas = $.map(jsonResult, function (item) {

                                        if (item.MRRAId != RiskFactorSetupVM.SelectedMRRAreaId()) {
                                            return new RRAreaModel(item);
                                        }
                                    });
                                    //  var res= jsonResult.filter(x => x.MRRAId !== RiskFactorSetupVM.ClickedFactorID())


                                    RiskFactorSetupVM.CopyAreasList(mappedareas);

                                    $('#copyareasMultiselect').multiselect();
                                    $('#copyareasMultiselect').multiselect('refresh');
                                }
                                if (jsonResult.length === 0) {
                                    $('#loadingMainImgDiv').hide();
                                    $('#errorAreas').show();
                                }
                            }

                            else {
                                $('#loadingMainImgDiv').hide();
                                // logger.logError('Some error occured while deleting the assessment type. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                            }

                        })
                        .fail(function (error, status) {
                            logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: GetRRAreas() method in RiskRatingConfiguration.js';
                    logger.logMessage(msg);
                }
            }



            //#endregion

            //#endregion

            //#region ResponseType Methods

            //#region getAllResponseTypes

            function getAllResponseTypes() {
                try {
                    $.ajax({
                        url: "/api/RiskRatingConfiguration/GetResponseTypes",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    })
                        .success(function (jsonResult, error) {
                            RiskFactorSetupVM.ResponseTypeList([]);

                            if (jsonResult) {
                                //var mappedresponse = $.map(jsonResult, function (item) {
                                //        return new RRResponseTypeModel(item);
                                //});
                                //RiskFactorSetupVM.ResponseTypeList(mappedresponse);

                                RiskFactorSetupVM.ResponseTypeList(jsonResult);
                                RiskFactorSetupVM.newResponseType('');
                            }
                        })
                        .fail(function (jsonResult, error) {
                            console.log("Error");
                            logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        });

                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: GetAllResponseTypes() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            //#endregion

            //#region  Add, Edit, Save ResponseType - PopUp & Methods

            function openResponseTypePopUp() {
                try {
                    //getAllResponseTypes();
                    RiskFactorSetupVM.ResponseTypeList();
                    RiskFactorSetupVM.newResponseType('');
                    $('#responseTypeModal').modal('show');
                    $('#modalContentRT').css({
                        'margin-top': 'auto'
                    });
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: openResponseTypePopUp() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function addResponseType() {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;

                    if (RiskFactorSetupVM.newResponseType() === '') {
                        $('#errorMessageRT').show();
                        $('#errorMessageRT').text('Response Type can not be empty!');
                        return false;
                    }
                    $('#errorMessageRT').hide();
                    $('#errorMessageRT').text('');

                    $.ajax({
                        url: "/api/RiskRatingConfiguration/AddResponseType?newResponseTypeName=" + RiskFactorSetupVM.newResponseType(),
                        type: "POST",
                        headers: headers
                    })
                        .success(addResponseTypeSuccess)
                        .fail(addResponseTypeFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in addResponseType() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
                function addResponseTypeSuccess(jsonResult, status) {
                    try {
                        if (jsonResult === 1) {
                            RiskFactorSetupVM.newResponseType("");
                            getAllResponseTypes();
                            logger.logSuccess('Response Type has been added successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                        } else {
                            logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetup), true);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addResponseType() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }

                function addResponseTypeFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addResponseType() method in RiskRatingFactorSetup.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in addResponseType() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }
            }

            function updateResponseType(data) {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;

                    $.ajax({
                        url: "/api/RiskRatingConfiguration/UpdateResponseType?ResponseTypeId=" + data.RRResponseTypeId + "&ResponseTypeName=" + data.RRResponseTypeName,
                        type: "POST",
                        headers: headers
                    })
                        .success(updateResponseTypeSuccess)
                        .fail(updateResponseTypeFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in updateResponseType() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }

                function updateResponseTypeSuccess(jsonResult, status) {
                    try {
                        if (jsonResult === 1) {
                            logger.logSuccess('Response Type has been edited successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                        } else {
                            logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in updateResponseItem() method in RiskRatingFactorSetup.js';
                        logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        logger.logMessage(msg);
                    }
                }

                function updateResponseTypeFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateResponseType() method in RiskRatingFactorSetup.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateResponseType() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }
            }

            //#endregion

            //#region Delete ResponseType Methods

            function deleteResponseType(data, event) {
                try {
                    app.showMessage('<b>Are you sure you want to delete this Response Type?<br/><br/><b>', 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                        .then(function (option) {
                            if (option === 'Confirm') {
                                deleteResponseItem(data);
                            }
                        });

                    setTimeout(function () {
                        $(event.target).focus();
                    }, 1);
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    return false;
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: deleteResponseType() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function deleteResponseItem(data) {
                try {
                    console.log(data.ID);
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;

                    $.ajax({
                        url: "/api/RiskRatingConfiguration/DeleteResponseType?ResponseTypeId=" + data.RRResponseTypeId,
                        type: "POST",
                        headers: headers
                    })
                        .success(deleteResponseSuccess)
                        .fail(deleteResponseFail);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in deleteResponseItem() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }

                function deleteResponseSuccess(jsonResult, status) {
                    try {
                        if (jsonResult > 0) {
                            logger.logSuccess('Response Type has been deleted successfully.', 'Success', system.getModuleId(RiskFactorSetupVM), true);
                            getAllResponseTypes();
                        } else {
                            logger.logError('The Response cannot be deleted as it is used in the Application.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteResponseItem() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }

                function deleteResponseFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Delete Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else if (error.status == 409) {
                            logger.logError('The Response cannot be deleted as it is used in the Application.', 'Error', system.getModuleId(RiskFactorSetupVM), true);
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteResponseItem() method in RiskRatingFactorSetup.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteResponseItem() method in RiskRatingFactorSetup.js';
                        logger.logMessage(msg);
                    }
                }
            }

            //#endregion

            //#endregion

            //#region Model Definitions

            function AssessmentListModel(item) {
                try {
                    var self = this;
                    self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
                    self.AssessmentName = ko.observable(item.AssessmentName);
                    self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
                    self.Description = ko.observable($('<div/>').html(item.Description).text());
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function RRFactorModel(item) {
                try {
                    var self = this;
                    self.RRFactorId = ko.observable(item.RRFactorId);
                    self.RRFactorName = ko.observable(item.RRFactorName);
                    self.RRFactorDescription = ko.observable(item.RRFactorDescription);
                    self.RRFactorType = ko.observable(item.RRFactorType);
                    self.RRFactorTypeDisplay = ko.observable(item.RRFactorTypeDisplay);
                    self.ConditionalParentId = ko.observable(item.ConditionalParentId);
                    self.ConditionalResponseIds = ko.observable(item.ConditionalResponseIds);
                    self.ResponseTypeIds = ko.observable(item.ResponseTypeIds);
                    self.ResponseTypeNames = ko.observable(item.ResponseTypeNames);
                    self.RRFactorOverallRank = ko.observable(item.RRFactorOverallRank);
                    self.ApplicableRATNamesRRF = ko.observable(item.ApplicableRATNamesRRF);
                    self.ApplicableRATIdsRRF = ko.observable(item.ApplicableRATIdsRRF);
                    self.RATArrayRRF = ko.observable(item.RATArrayRRF);
                    self.CopyOverAreas = ko.observable(item.CopyOverAreas);
                    self.CopyOverAreasNames = ko.observable(item.CopyOverAreasNames);
                    self.ResponseTypesRRF = ko.observable(item.ResponseTypesRRF);
                    var mappedLangList = $.map(item.LanguageData, function (result) {
                        return new RRLanguageDataModel(result);
                    });
                    self.WantsAutoHigh = ko.observable(item.WantsAutoHigh);
                   // self.WantsAutoHighresponsesub = "";
                    self.LanguageData = ko.observable(mappedLangList);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: RRFactorModel() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function RRLanguageDataModel(item) {
                try {
                    var self = this;
                    self.LanguageFactorId = ko.observable(item.LanguageFactorId);
                    self.LanguageFactorName = ko.observable(item.LanguageFactorName);
                    self.LanguageFactorDescription = ko.observable(item.LanguageFactorDescription);
                    self.LanguageId = ko.observable(item.LanguageId);
                    var LName = getLanguageName(item.LanguageId);
                    self.Name = ko.observable("Risk Factor Name (" + LName + ")");
                    self.Description = ko.observable("Risk Factor Description (" + LName + ")");
                    self.NameSubFactor = ko.observable("Response in " + LName);
                    self.UIdName = ko.observable('FactorName' + item.LanguageId);
                    self.UIdDesc = ko.observable('FactorDesc' + item.LanguageId);
                    self.UIdSF = ko.observable('SFName' + item.LanguageId);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: RRLanguageDataModel() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function SubFactorModel(item) {
                try {
                    var self = this;
                    self.RRSubFactorId = ko.observable(item.RRSubFactorId);
                    self.RRSubFactorName = ko.observable(item.RRSubFactorName);
                    self.RRSubAutoHighResp = ko.observable(item.RRSubAutoHighResp);
                    self.RRSubFactorDescription = ko.observable(item.RRSubFactorDescription);
                    self.RATMapIRLId = ko.observable(item.RATMapIRLId);
                    self.RATMapIRLName = ko.observable(item.RATMapIRLName);
                    self.ResponseTypeIdsRRSF = ko.observable(item.ResponseTypeIdsRRSF);
                    self.ResponseTypeNamesRRSF = ko.observable(item.ResponseTypeNamesRRSF);
                    self.RRSubFactorOverallRank = ko.observable(item.RRSubFactorOverallRank);
                    self.ApplicableRATNamesRRSF = ko.observable(item.ApplicableRATNamesRRSF);
                    self.ApplicableRATIdsRRSF = ko.observable(item.ApplicableRATIdsRRSF);
                    self.RATArrayRRSF = ko.observable(item.RATArrayRRSF);
                    var mappedLangSubList = $.map(item.LanguageDataRRSF, function (result) {
                        return new RRLanguageDataModel(result);
                    });
                    self.LanguageDataRRSF = ko.observable(mappedLangSubList);
                    //self.WantsAutoHighresponsesub = ko.observable(false);
                    //self.WantsAutoHighresponsesub = ko.observable(item.WantsAutoHighresponsesub);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: SubFactorModel() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function RRAreaModel(item) {
                try {
                    var self = this;
                    self.MRRAId = ko.observable(item.MRRAId);
                    self.MRRAName = ko.observable(item.MRRAName);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: RRItemModel() method in RiskRatingConfiguration.js';
                    logger.logMessage(msg);
                }
        }

        function RRResponseTypeModel(item) {
            try {
                var self = this;
                self.RRResponseTypeId = ko.observable(item.RRResponseTypeId);
                self.RRResponseTypeName = ko.observable(item.RRResponseTypeName);
                self.RRResponseTypeDescription = ko.observable(item.RRResponseTypeDescription);
                self.RRResponseTypeOverallRank = ko.observable(item.RRResponseTypeOverallRank);
            
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRItemModel() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

            function RiskLevelModel(item) {
                try {
                    var self = this;
                    self.RiskLevelId = item.RiskLevelId;
                    self.RiskLevelName = item.RiskLevelName;
                    self.RiskLevelShortText = item.RiskLevelShortName;
                    self.ScoringType = item.ScoringType;
                    self.LevelCount = item.RiskLevelCount;
                    self.AssessmentTypeId = item.AssessmentId;
                    self.MappedRiskLevels = $.map(item.RiskLevelDetailsModel, function (result) {
                        return new InherentRiskLevelModel(result);
                    });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function InherentRiskLevelModel(item) {
                try {
                    var self = this;
                    self.RiskLevelId = item.RiskLevelId;
                    self.RiskLevelParentId = item.RiskLevelParentId;
                    self.RiskLevelcss = item.CSS;
                    self.RiskLevelComents = item.RiskLevelComents;
                    self.RiskLevelDescription = item.RiskLevel + ' - ' + item.RiskLevelDescription;
                    self.RiskLevel = item.RiskLevel;
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: InherentRiskLevelModel() method in RiskRatingFactorSetup.js';
                    logger.logMessage(msg);
                }
            }

            function jsTreeModel(item) {
                var self = this;

                self.id = item.AreaLevelId.toString();
                self.text = item.AreaLevelName;
                if (RiskFactorSetupVM.AreaLeveljstree()[self.id].length > 0) {
                    self.nodes = $.map(RiskFactorSetupVM.AreaLeveljstree()[self.id], function (result) {
                        return new jsTreeModel(result);
                    });
                }
                self.ParentAreaLevelId = item.ParentAreaLevelId;
                self.state = { expanded: false };
                self.dead_node = item.DeadNode;
                self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
                self.RA_Type = ko.observable(item.RA_Type);

            }

        
        //#endregion

    });
